import React from 'react'
import ReactDOM from 'react-dom'
import StudentAnalytics from './components/StudentAnalytics'

const pathArray = window.location.pathname.split('/')
const coursenum = pathArray[3]
const initialChapterFilter = pathArray[4] === undefined ? '' : pathArray[4]
const initialStudentFilter = pathArray[5] === undefined ? '' : pathArray[5]

export let startApp = () => {
  ReactDOM.render(
    <StudentAnalytics
      coursenum={coursenum}
      initialStudentFilter={initialStudentFilter}
      initialChapterFilter={initialChapterFilter}
    />,
    document.getElementById('react-app')
  )
}
